import { useCallback, useMemo, useState } from "react";

const LocalStorageKey = "calauto-gemini-api-key";

export function useGeminiApiKey() {
  const [geminiApiKey, setGeminiApiKey] = useState<string | null>(() => {
    const geminiApiKey = localStorage.getItem(LocalStorageKey);
    return geminiApiKey ?? null;
  });

  const handleSetGeminiApiKey = useCallback(
    (newGeminiApiKey: string) => {
      setGeminiApiKey(newGeminiApiKey);
      localStorage.setItem(LocalStorageKey, newGeminiApiKey);
    },
    [setGeminiApiKey]
  );

  return useMemo(() => {
    return { geminiApiKey, setGeminiApiKey: handleSetGeminiApiKey };
  }, [geminiApiKey, handleSetGeminiApiKey]);
}
